<script>
import General from '@/services/General'
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      showModal: false,
      title: "",
      start_at: "",
      date: "",
      time: "",
      location: "",
      eventLimit: "",
      userLimit: "",
      companyLimit: "",
      toc: "",
      image: "",
      content: "",
      activeLabel: "Inactive",
      appButtonColor: "#e30613",
      appButtonTextColor: "#ffffff",
    };
  },
   async created() {
        await this.loadAppButtonColors();
       },
  methods: {
    decodeHtmlEntities(value) {
      const str = String(value || "");
      const textarea = document.createElement("textarea");
      textarea.innerHTML = str;
      return textarea.value;
    },
    splitDateTime(raw) {
      const str = String(raw || "").trim();
      if (!str) return { date: "", time: "" };
      const parts = str.split(" ");
      if (parts.length >= 2) {
        return { date: parts[0], time: parts[1].slice(0, 5) };
      }
      return { date: str, time: "" };
    },
    resolvePreviewContent(eventData) {
      if (eventData.original_content) {
        return this.decodeHtmlEntities(eventData.original_content);
      }
      const raw = String(eventData.content || "");
      if (!raw) return "";
      const val = String(raw || "");
      try {
        const parsed = JSON.parse(val);
        if (parsed && Array.isArray(parsed.articleContent)) {
          return parsed.articleContent
            .map((block) => block?.text || "")
            .filter(Boolean)
            .map((text) => `<p>${text}</p>`)
            .join("");
        }
      } catch (e) {
        // Fallback for html/plain strings.
      }
      return this.decodeHtmlEntities(val);
    },
    async loadAppButtonColors() {
      try {
        const colors = await General.getAppButtonColors();
        Object.assign(this, colors);
      } catch (error) {
        // keep default colors if request fails
      }
    },
    populateFields() {
      const d = this.data || {};
      const eventInfo = d.event_info || {};
      const normalizedStartAt = d.start_at || eventInfo.start_at || "";

      this.title = d.title || "/";
      this.start_at = normalizedStartAt || "/";
      const dt = this.splitDateTime(normalizedStartAt);
      this.date = dt.date || "";
      this.time = dt.time || "";
      this.location = d.location || eventInfo.location || "/";
      this.eventLimit =
        d.registrationLimit || eventInfo.registrationLimit || d.event_limit || "/";
      this.userLimit = d.userLimit || eventInfo.userLimit || d.user_limit || "/";
      this.companyLimit =
        d.companyLimit || eventInfo.companyLimit || d.company_limit || "/";
      this.toc = d.toc || eventInfo.toc || "";
      this.image = d.image || "";
      this.activeLabel = d.active === 1 ? "Active" : "Inactive";

      this.content = this.resolvePreviewContent(d);
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<template>
  <b-modal
    id="view_business_event_mobile_preview"
    v-model="showModal"
    title="Event Mobile Preview"
    @shown="populateFields"
    title-class="font-18"
    size="xl"
    hide-footer
  >
    <div class="row g-3">
      <div class="col-lg-6">
        <div class="card h-100 border">
          <div class="card-body">
            <h5 class="mb-3">Event Information</h5>
            <div class="row">
              <div class="col-6 mb-3">
                <small class="text-muted d-block">Event Name</small>
                <strong>{{ title || "/" }}</strong>
              </div>
              <div class="col-6 mb-3">
                <small class="text-muted d-block">Status</small>
                <strong>{{ activeLabel }}</strong>
              </div>
              <div class="col-6 mb-3">
                <small class="text-muted d-block">Date & Time</small>
                <strong>{{ start_at || "/" }}</strong>
              </div>
              <div class="col-6 mb-3">
                <small class="text-muted d-block">Location</small>
                <strong>{{ location || "/" }}</strong>
              </div>
              <div class="col-4 mb-3">
                <small class="text-muted d-block">Event Limit</small>
                <strong>{{ eventLimit || "/" }}</strong>
              </div>
              <div class="col-4 mb-3">
                <small class="text-muted d-block">User Limit</small>
                <strong>{{ userLimit || "/" }}</strong>
              </div>
              <div class="col-4 mb-3">
                <small class="text-muted d-block">Company Limit</small>
                <strong>{{ companyLimit || "/" }}</strong>
              </div>
              <div class="col-12 mb-2" v-if="toc">
                <small class="text-muted d-block">Terms & Conditions</small>
                <a :href="toc" target="_blank" rel="noopener noreferrer">{{ toc }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card h-100 border">
          <div class="card-body py-2 d-flex flex-column">
            <h5 class="mb-3">
              <i class="uil uil-mobile-android me-1"></i>
              Mobile Preview
            </h5>
            <div class="flex-grow-1 d-flex align-items-center justify-content-center">
              <div style="width: 100%; display: flex; justify-content: center;">
                <div
                  style="
                    width: 310px;
                    max-width: 100%;
                    border-radius: 32px;
                    border: 2px solid #e5e7eb;
                    padding: 14px;
                    background: #0b1120;
                    box-shadow: 0 18px 45px rgba(15,23,42,0.45);
                    position: relative;
                  "
                >
                  <div
                    style="
                      border-radius: 22px;
                      overflow: hidden;
                      background: #f3f4f6;
                      color: #111827;
                      font-size: 13px;
                      display: flex;
                      flex-direction: column;
                      min-height: 420px;
                    "
                  >
                    <div
                      :style="{
                        background: appButtonColor,
                        color: '#fff',
                        textAlign: 'center',
                        padding: '33px 12px',
                        fontWeight: '700',
                        fontSize: '15px',
                        letterSpacing: '0.12em',
                        textTransform: 'uppercase',
                        height: '60px',
                      }"
                    >
                      BUSINESS NEWS
                    </div>

                    <div style="padding: 10px 10px 12px 10px;">
                      <div
                        style="
                          background: #ffffff;
                          border-radius: 16px;
                          overflow: hidden;
                        "
                      >
                        <div v-if="image">
                          <img :src="image" alt="Preview" style="width: 100%; height: 130px; object-fit: cover;">
                        </div>
                        <div
                          v-else
                          style="
                            height: 130px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #e5e7eb;
                            color: #6b7280;
                            font-size: 12px;
                          "
                        >
                          Header image preview
                        </div>

                        <div
                          style="
                            padding: 10px 12px 6px;
                            border-bottom: 1px solid #f3f4f6;
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            gap: 8px;
                          "
                        >
                          <div style="flex: 1 1 auto; min-width: 0;">
                            <div
                              style="
                                font-weight: 700;
                                font-size: 14px;
                                line-height: 1.3;
                                margin-bottom: 4px;
                                color: #111827;
                              "
                            >
                              {{ title || 'Business trip Sevilla' }}
                            </div>
                            <div style="font-size: 11px; color: #6b7280;">
                              <i class="uil uil-map-marker font-size-15 text-secondary me-1"></i>
                              {{ location || 'Amsterdam, Netherlands' }}
                            </div>
                            <div style="font-size: 11px; color: #6b7280; margin-top: 2px;">
                              <i class="uil uil-clock me-1 font-size-15"></i>
                              {{ date || '01-01-2026' }}, <span>{{ time || '16:00' }}</span>
                            </div>
                          </div>

                          <div
                            style="
                              display: flex;
                              align-items: center;
                              flex-shrink: 0;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                padding-right: 4px;
                              "
                            >
                              <div
                                style="
                                  width: 22px;
                                  height: 22px;
                                  border-radius: 9999px;
                                  background: linear-gradient(135deg, #fee2e2, #fecaca);
                                  border: 2px solid #ffffff;
                                  box-shadow: 0 0 0 1px #e5e7eb;
                                "
                              ></div>
                              <div
                                style="
                                  width: 22px;
                                  height: 22px;
                                  border-radius: 9999px;
                                  background: linear-gradient(135deg, #e0f2fe, #bae6fd);
                                  border: 2px solid #ffffff;
                                  box-shadow: 0 0 0 1px #e5e7eb;
                                  margin-left: -8px;
                                "
                              ></div>
                              <div
                                style="
                                  width: 22px;
                                  height: 22px;
                                  border-radius: 9999px;
                                  background: linear-gradient(135deg, #ede9fe, #ddd6fe);
                                  border: 2px solid #ffffff;
                                  box-shadow: 0 0 0 1px #e5e7eb;
                                  margin-left: -8px;
                                "
                              ></div>
                            </div>
                            <div
                              :style="{
                                background: appButtonColor,
                                color: appButtonTextColor,
                                borderRadius: '9999px',
                                padding: '2px 6px',
                                fontSize: '10px',
                                fontWeight: '700',
                                lineHeight: '1',
                                minWidth: '26px',
                                textAlign: 'center',
                              }"
                            >
                              10+
                            </div>
                          </div>
                        </div>

                        <div
                          style="
                            padding: 6px 12px 12px;
                            font-size: 12px;
                            color: #4b5563;
                            height: 200px;
                          "
                        >
                          <div v-if="content" v-html="content"></div>
                          <div v-else>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec in odio ut leo vestibulum porttitor non quis dolor.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style="
                        padding: 0 10px 10px 10px;
                        margin-top: auto;
                        display: flex;
                        justify-content: center;
                      "
                    >
                      <div
                        :style="{
                          background: appButtonColor,
                          color: appButtonTextColor,
                          fontWeight: '700',
                          fontSize: '13px',
                          padding: '9px 80px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.16em'
                        }"
                      >
                        <span style="display: inline-block;">
                          SIGN UP
                        </span>
                      </div>
                    </div>

                    <div
                      :style="{
                        background: appButtonColor,
                        height: '50px',
                      }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <b-button variant="light" @click="closeModal">Close</b-button>
    </div>
  </b-modal>
</template>

<style scoped>

</style>
